import { IPreloadedState } from 'shared/types/redux';

export const selectHouseGeo = (state: IPreloadedState) => state.houseInfo.geo;
